<template>
    <div class="all-candidates">
        <!-- tab -->
        <div class="all-candidates_tab">
            <div class="tab-list flex-center">
                <div
                    :class="['tab-item', { active: tab.status === currentStatus }]"
                    v-for="tab in tabOptions"
                    :key="tab.status"
                    @click="currentStatus = tab.status"
                >
                    {{ tab.label }} ({{ getTabCount(tab.status) }})
                </div>
            </div>

            <div class="tab-filter flex-center" @click="handleOrderChange">
                <div class="sort-icon">
                    <i class="el-icon-caret-top" :class="[{ active: order === 'asc' }]"></i>
                    <i class="el-icon-caret-bottom" :class="[{ active: order === 'desc' }]"></i>
                </div>
                报名时间
            </div>
        </div>

        <!-- 报名人列表 -->
        <div class="task-plan" v-if="currentApplyList.length > 0">
            <PlanItem
                v-for="(plan, index) in currentApplyList"
                :key="index"
                :plan="plan"
                :operates="getTabCount(1) <= 0 && [3, 5].includes(role)"
                :task-mode="taskData?.task_mode"
                :user-id="taskData?.user_id"
                @action="handlePlanAction"
            ></PlanItem>
        </div>

        <div class="all-candidates_empty flex-center" v-else>
            <img src="@/assets/img/task-center/candidates-empty.png" alt="" />
            <span>当前筛选条件暂无数据......</span>
        </div>
    </div>
</template>

<script>
import PlanItem from "./PlanItem.vue";
import { request } from "../../util";
import taskApi from "@/apis/task";

export default {
    data() {
        return {
            role: Number(localStorage.getItem("role")), // 角色 5-企业，4-学生
            currentStatus: 0, // 0-all， 1-中标，2-备选，3-淘汰， 4-已取消-前端不展示
            order: "", // 排序 desc, asc
            tabOptions: [
                { status: 0, label: "全部" },
                { status: 1, label: "中标" },
                { status: 2, label: "备选" },
                { status: 3, label: "淘汰" },
            ],

            request: request(),
        };
    },

    props: {
        taskData: {
            type: Object,
        },
        applyList: {
            type: Array,
            default: () => [],
        },
    },

    components: {
        PlanItem,
    },

    computed: {
        // 过滤计划列表数据
        filterApplyList() {
            // // 学生, 且是招募模式
            // if (this.role === 4 && this.taskData?.task_mode === 1) {
            //     // 只能查看自己的报名信息
            //     return this.applyList.filter((item) => item.user_id === Number(localStorage.getItem("id")));
            // } else {
            //     // 其他情况,返回所有
            //     return this.applyList;
            // }
            return this.applyList;
        },

        // 当前tab选中的报名列表数据
        currentApplyList() {
            let list = [];

            if (this.currentStatus === 0) list = JSON.parse(JSON.stringify(this.filterApplyList));
            else list = this.filterApplyList?.filter((item) => item.status === this.currentStatus);

            if (this.order === "") return list;
            else
                return list.sort((a, b) => {
                    const aTime = new Date(a.create_time).getTime();
                    const bTime = new Date(b.create_time).getTime();

                    return this.order === "asc" ? aTime - bTime : bTime - aTime;
                });
        },
    },

    methods: {
        // 获取tab中有多少数据
        getTabCount(status) {
            const filterApplyList = status === 0 ? this.applyList : this.applyList?.filter((item) => item.status === status);
            return filterApplyList.length ?? 0;
        },

        // 排序点击
        handleOrderChange() {
            const orderList = ["", "asc", "desc"];
            const currentIndex = orderList.findIndex((item) => item === this.order);

            this.order = orderList[(currentIndex + 1) % 3];
        },

        // 人选操作回调
        handlePlanAction(type, plan) {
            // 中标
            if (type === "win-bid") {
                this.$confirm(`是否确认选择${plan.user_info?.name}为你服务`, "选择TA", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    customClass: "ek-confirm warning",
                }).then(() => {
                    this.changeApplyStatus(1, "", plan);
                });
            } else {
                this.$emit("statusAction", type, plan);
            }
        },

        // 修改学生报名状态
        changeApplyStatus(status, reply, val) {
            const params = {
                task_id: val.task_id,
                apply_id: val.id,
                status: status,
                reply: reply,
            };

            this.$emit("changeStatus", taskApi.changeApplyStatus, params, ["getDetail", "getApplyList"]);
        },
    },
};
</script>

<style lang="scss" scoped>
.all-candidates {
    &_tab {
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
        background-color: #ffffff;
        height: 60px;
        gap: 30px;
        padding-inline: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .tab-list {
            gap: 22px;

            .tab-item {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #666666;
                cursor: pointer;

                &.active {
                    color: #4f61f1;
                }
            }
        }

        .tab-filter {
            cursor: pointer;

            .sort-icon {
                display: flex;
                flex-direction: column;
                color: #999999;

                i {
                    height: 8px;

                    &::before {
                        display: block;
                        line-height: 8px;
                        height: 8px;
                    }
                }

                i.active {
                    color: #273be6;
                }
            }
        }
    }

    &_empty {
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
        height: 500px;
        background-color: #ffffff;
        flex-direction: column;
        gap: 20px;
        margin-top: 20px;

        img {
            height: 280px;
            width: auto;
            object-fit: cover;
        }

        span {
            font-weight: 400;
            font-size: 16px;
            color: #666666;
        }
    }
}
</style>
